<template>
	<div class="fill-height">	
		<v-navigation-drawer
			v-if="showDraft"
			absolute
			permanent
			right
			width="300"
			height="100%"
		>
			<!-- <v-card class="rounded-lg rounded-b-0" height="100%"> -->
				<v-list-item class="mt-2">
					<v-row class="mt-0">
						<v-col class="py-0">
							<h3> Draft tasks </h3>
						</v-col>
						<v-col class="py-0 d-flex justify-end">
							<v-btn icon @click="showDraft = !showDraft">
								<v-icon> mdi-view-list  </v-icon>
							</v-btn>
						</v-col>
					</v-row>		
				</v-list-item>

				<v-divider></v-divider>

				<v-list-item  two-line>						
					<v-text-field v-model="searchText" append-icon="mdi-magnify " dense outlined filled label="Search" hide-details @input="items.filter(c => c.content.includes(searchText))" />
				</v-list-item>
				
				<v-divider></v-divider>

				<v-list dense>
					<v-list-item
						v-for="(task) in (searchText !== null ? items.filter(c => c.content.includes(searchText)) : items)"
						:key="task.id"
						class="droptarget my-0 py-0 h-auto px-0 ms-1 me-0 scroll-style"
						v-on:drop="drop"
						@dragover="allowDrop"
						dense
					>
						<v-list-item-content 
							v-on:dragstart="dragStart"
							v-on:drag="dragging"
							draggable="true"
							class="py-0"
							:id="task.id"
						>
							<!-- <v-card class="py-0 rounded-lg rounded-r-0 style-small-draft-card"> -->
								<v-col class="text-center py-1 d-flex" 
									:class="{
										'flex-wrap': $vuetify.breakpoint.mdAndDown
									}" 
									align-self="center" 
									cols="12"
								>
									<div
										id="card"
										style="width: auto"
										class="my-0 pa-1 mx-1 rounded-lg my-grey"
										:class="{ 
											'task-card': $vuetify.breakpoint.lgAndUp,
											'h-auto my-1': $vuetify.breakpoint.lgAndDown,
											'w-100': $vuetify.breakpoint.mdAndDown
										}"
									>
										<v-col class="h-100 pt-0 d-flex flex-column">
											<v-row class="mt-0 pt-0">
												<v-col cols="7" class="py-0 text-start ">
													<span 
														class=" fs-12" 
														:class="{
															'white--text': $vuetify.theme.dark,
															'primary--text': !$vuetify.theme.dark,
														}"
													> 
														{{
															userTypeUser === userType.Developer ?
															currentUserProjects.find(c => c.id === task.projectId)?.name :
															projectsBrief.find(c => c.id === task.projectId)?.name
														}}
													</span>
												</v-col>
												<v-col cols="5" class="py-0 text-end">
													<span>
														<span
															class="px-2 py-1 rounded-pill fs-11 no-task-style"
															:class="{
																'bg-light-blue': !$vuetify.theme.dark ,
																'bg-light-grey white--text':  $vuetify.theme.dark 
															}"
														> 
															{{ task.taskNo }} 
														</span>
													</span>
												</v-col>
											</v-row>
											<!-- text -->
											<v-row>
												<v-col class="text-start py-0 line-h-1-3">
													<!-- 'black--text': $vuetify.theme.dark && !task.isDone -->
													<span v-if="$vuetify.breakpoint.width < 1800" class="fs-12" 
														dir="auto"
													>
														{{	
															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
																(Number(((task.durationInMinute)/60).toFixed(2))) < 2 
															) ? 
															task.content.length > 35 ? (task.content.slice(0, 35) + '...'): task.content :

															(
																(Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
																(	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
																	((((task.durationInMinute)/60).toFixed(2))) > 2
																) 
															) ? 
															task.content.length > 55 ? (task.content.slice(0, 55) + '...'): task.content  : 

															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
																( 
																	(Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 3
																) 
															)? 
															task.content.length > 68 ? (task.content.slice(0, 68) + '...'): task.content 

															: task.content.length > 70 ? (task.content.slice(0, 70) + '...') : task.content
														}}
													</span>

													<span v-if="$vuetify.breakpoint.width >= 1800" class="fs-12">
														
														{{	
															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
																(Number(((task.durationInMinute)/60).toFixed(2))) < 2 
															) ? 
															task.content.length > 60 ? (task.content.slice(0, 60) + '...'): task.content :

															(
																(Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
																(	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 2
																) 
															) ? 
															task.content.length > 90 ? (task.content.slice(0, 90) + '...'): task.content  : 

															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
																( 
																	(Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 3
																) 
															)? 
															task.content.length > 100 ? (task.content.slice(0, 100) + '...'): task.content 

															: task.content.length > 115 ? (task.content.slice(0, 115) + '...') : task.content
														}}
													</span>
												</v-col>
											</v-row>
											<v-row v-if="0">
												<v-col cols="12" class="text-start py-0" align-self="end">
													<v-icon 
														size="15" 
														class="me-1" 
														:class="{
															'white--text': task.isDone
														}"
													> 
														mdi-clock-time-four-outline  
													</v-icon>
													<span v-if="task.isDone" class="fs-11 white--text">
														{{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
													</span>
													<span class="fs-11" :class="{'white--text': task.isDone}"> 
														/ {{ task.durationInMinute / 60 }} h
													</span>
													
												</v-col>
											</v-row>
											<!--  -->
											<v-row class="">
												<v-col align-self="end" cols="12" class=" py-1">
													<v-row justify="end">
														<v-col cols="auto" class="text-start" align-self="start">
															<v-icon 
																size="15" 
																class="me-1" 
															> 
																mdi-clock-time-four-outline  
															</v-icon>
															<span class="fs-11" > 
																{{ task.durationInMinute / 60 }} h
															</span>
														</v-col>
														<v-spacer />
														<v-row 
															cols="auto" 
															align="center" 
															class=" py-0 d-flex"
															:class="{
																'justify-center': $vuetify.breakpoint.lg,
																'justify-end mx-1': $vuetify.breakpoint.mdAndDown
															}"
														>
															<v-btn	
																v-if="
																	(
																		$route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
																	) || 
																	(
																		$route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days'))
																	)
																"
																icon
																@click="taskId = task.id; dialog = true"
																:disabled="loading"
																color="gray"
															>
																<v-icon small> mdi-pencil </v-icon>
															</v-btn>

															<v-btn 
																icon 
																v-else 
																@click="taskId = task.id; view = true; dialog = true"
																x-small
															>
																<v-icon color="edit-color"> mdi-eye </v-icon>
															</v-btn>
														
															<v-btn
																v-if="
																	(
																		$route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
																	) || 
																	(
																		$route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days'))
																	)
																"
																:disabled="loading"
																icon
																@click="taskId = task.id; deleteDialog = true"
																color='gray'
															>
																<v-icon small> mdi-delete </v-icon>
															</v-btn>
											
															<!-- <v-btn
																v-if="0"
																:disabled="loading"
																icon
																@click="taskId = task.id; status = task.isDone; task.doneLoading = true; changeToDone()"
																:color="task.isDone ? 'white' : 'green' "
																:loading="Boolean(task.doneLoading)"
															>
																<v-icon v-if="task.isDone"> mdi-swap-horizontal </v-icon>
																<v-icon v-if="!task.isDone" small> mdi-check-circle  </v-icon>
															</v-btn> -->
														</v-row>
													</v-row>
												</v-col>
											</v-row>
										</v-col>
										
									</div>
								</v-col>
							<!-- </v-card> -->
						</v-list-item-content>
					</v-list-item>
				</v-list>
			<!-- </v-card> -->
		</v-navigation-drawer>
		<div v-if="!loading" class="fill-height pt-2" :class="{ 'd-flex align-center justify-center': loading }">
			<!-- card -->
			<v-card :width="$vuetify.breakpoint.width - 100"  class="week-card rounded-lg">
				<v-card-text dir="auto">  
					<div v-if="$vuetify.breakpoint.mdAndDown" class="d-flex justify-space-between">
						<div 
							v-if="userTypeUser === userType.Admin || userTypeUser === userType.Administrative" class="d-flex"
						>
							<v-icon color="primary" class="me-2"> mdi-account </v-icon>
							<v-autocomplete
								v-model="userIdUser"
								:items="usersWithoutPag"
								:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
								item-value="id"
								label="Employees"
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								hide-details="auto"
								class="input"
								@change="getActivePlanForUser()"
							/>
						</div>
						<div class="d-flex justify-center" align-self="center">
							<v-btn
								v-if="planIsDone"
								@click="newPlanDialog = true"
								color="success-light white--text"
								class="text-none mb-1 rounded-lg"
								:disabled="loading"
							>
								<v-icon class="pe-2"> mdi-plus-circle </v-icon>
								Add Plan 
							</v-btn>

							<!-- v-if="" -->
							<v-btn
								v-if="!planIsDone"
								@click="updatePlanToDone()"
								color="success-light white--text"
								class="text-none rounded-lg mb-1"
								:disabled="loading"
							>
								<v-icon class="pe-2"> mdi-check </v-icon>
								Done 
							</v-btn>

							<v-btn icon @click="showDraft = !showDraft">
								<v-icon> mdi-view-list  </v-icon>
							</v-btn>
						</div>
					</div>
					<v-row class="d-flex justify-center py-3">
						<v-col 
							cols="2" 
							v-if="(userTypeUser === userType.Admin && $vuetify.breakpoint.lgAndUp) || 
							(userTypeUser === userType.Administrative && $vuetify.breakpoint.lgAndUp)" 
							class="d-flex"
						>
							<v-icon color="primary" class="me-2"> mdi-account </v-icon>
							<v-autocomplete
								v-model="userIdUser"
								:items="usersWithoutPag"
								:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
								item-value="id"
								label="Employees"
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								hide-details="auto"
								dense
								@change="getActivePlanForUser()"
								class="input"
							/>
						</v-col>
				
						<v-spacer /> 
					
						<v-col cols="auto" align-self="center" class="px-0">
							<!-- previous() -->
							<a @click="previous = true; getPlanBetweenTwoDate()">
								<v-img src="../../assets/Vectors/Group 9.png" contain width="25" />
							</a>
						</v-col>
						<v-col align-self="center" cols="auto">
							<span>
								{{ startDatePlan ? 
									moment(startDatePlan).format('dddd') 
									+ ' ' 
									+ moment(startDatePlan).format('llll').split(' ')[2] 
									+ '  ' + moment(startDatePlan).format('llll').split(' ')[1] 
									: 'Start Date'
								}} - 
							
								{{ endDatePlan ? 
									moment(startDatePlan).format('dddd') 
									+ ' ' 
									+ moment(endDatePlan).format('llll').split(' ')[2] 
									+ '  ' + moment(endDatePlan).format('llll').split(' ')[1]  
								: 'End Date' 
								}}
							</span>
						</v-col>
						<v-col cols="auto" align-self="center" class="px-0" >
							<!-- next() -->
							<a @click="previous = false; getPlanBetweenTwoDate()">
								<v-img src="../../assets/Vectors/Group 9.png" contain width="25" class="reverse-icon" />
							</a>
						</v-col>
						<v-spacer />
						<v-col 
							v-if="$vuetify.breakpoint.lgAndUp" 
							cols="auto"
							class="d-flex justify-center py-0" 
							align-self="center"
						>
							<v-btn
								v-if="planIsDone"
								@click="newPlanDialog = true"
								color="success-light white--text"
								class="text-none mb-1 rounded-lg"
								:disabled="loading"
							>
								<v-icon class="pe-2"> mdi-plus-circle </v-icon>
								Add Plan 
							</v-btn>

							<!-- v-if="" -->
							<v-btn
								v-if="!planIsDone"
								@click="updatePlanToDone()"
								color="success-light white--text"
								class="text-none rounded-lg mb-1"
								:disabled="loading"
							>
								<v-icon class="pe-2"> mdi-check </v-icon>
								Done 
							</v-btn>

							<!-- <v-btn icon @click="showDraft = !showDraft">
								<v-icon> mdi-view-list  </v-icon>
							</v-btn> -->
						</v-col>
					</v-row>
						
					<v-divider v-if="!loading"  class="" />
					<template v-if="!loading">
						<v-col v-for="(day, i) in week" :key="i" class="py-0" >
							<!-- new line -->
							<v-row 
								align="center" 
								class="h-one-row d-flex flex-wrap my-3"
								style= "height: auto"
								:class="{'h-auto my-3': $vuetify.breakpoint.mdAndDown}"
								v-on:dragend="dateDate = day.date"
								v-on:drop="drop"
								@dragover="allowDrop"
							>
								<v-col cols="1" align-self="center" class="text-center">
									<p class="mb-0 fw-4 text--color"> 
										{{ moment(moment(day.date)).format('YYYY-MM-DD').split('-')[2] }}
									</p>
									<p class="mb-0"> {{ day.name }} </p>
								</v-col>

								<v-divider vertical class="my-0" />
				
								<v-col v-if="!day.tasks.length"  class="text-center" align-self="center">
									<v-btn
										v-if="
											($route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day'))
											|| ($route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days')))
										"
										@click="rowId = day.id; dialog = true"
										text
										class="Urbanist-font text-none hover"
										:disabled="noPlan"
									
									>
										<!-- :disabled="Boolean(planByEmployee.length === 0)" -->
										<v-icon size="35" color="success-light" class="mx-2"> mdi-plus-circle </v-icon>
										Add Task
									</v-btn>
								</v-col>
								<v-col v-else class="text-center py-1 d-flex flex-wrap" :class="{
									'flex-wrap': $vuetify.breakpoint.mdAndDown
								}" align-self="center" >
									<div
										id="demo"
										v-for="(task, index) in day.tasks" 
										:key="index"
										class="my-1 pa-1 mx-1 rounded-lg"
										:class="{ 
											'width-1': (Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
											(Number(((task.durationInMinute)/60).toFixed(2))) < 2,

											'width-2': (Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
											(2 < (Number(((task.durationInMinute)/60).toFixed(2))) && (Number(((task.durationInMinute)/60).toFixed(2))) < 3 ),

											'width-3': (Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
											( (Number(((task.durationInMinute)/60).toFixed(2))) < 4 && (Number(((task.durationInMinute)/60).toFixed(2))) > 3),
											
											'width-4': (Number(((task.durationInMinute)/60).toFixed(2))) === 4,

											'task-card-done': task.isDone,
											'task-card': !task.isDone && $vuetify.breakpoint.lgAndUp,
											'h-auto my-1': $vuetify.breakpoint.lgAndDown,
											'my-grey': !task.isDone,
											'w-100': $vuetify.breakpoint.mdAndDown
										}"
									>
									<!-- {{ Number(((task.durationInMinute)/60).toFixed(2)) }} -->
										<v-col class="h-100 pt-0 d-flex flex-column">
											<v-row class="mt-0 pt-0">
												<v-col cols="7" class="py-0 text-start ">
													<span 
														class=" fs-12" 
														:class="{
															'white--text': task.isDone || $vuetify.theme.dark,
															'primary--text': !task.isDone && !$vuetify.theme.dark,
														}"
													> 
														{{
															userTypeUser === userType.Developer ?
															currentUserProjects.find(c => c.id === task.projectId)?.name :
															projectsBrief.find(c => c.id === task.projectId)?.name
														}}
													</span>
												</v-col>
												<v-col cols="5" class="py-0 text-end">
													<span>
														<span
															class="px-2 py-1 rounded-pill fs-11"
															:class="{ 
																'no-task-style-green bg-light-green': task.isDone,
																'bg-light-blue': !$vuetify.theme.dark && !task.isDone,
																'bg-light-grey white--text':  $vuetify.theme.dark && !task.isDone,
																'no-task-style': !task.isDone
															}"
														> 
															{{ task.taskNo }} 
														</span>
													</span>
												</v-col>
											</v-row>
											<!-- text -->
											<v-row>
												<v-col class="text-start py-0 line-h-1-3">
													<!-- 'black--text': $vuetify.theme.dark && !task.isDone -->
													<span v-if="$vuetify.breakpoint.width < 1800" class="fs-12" 
														:class="{ 
															'white--text': task.isDone,	
														}"
														dir="auto"
													>
														{{	
															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
																(Number(((task.durationInMinute)/60).toFixed(2))) < 2 
															) ? 
															task.content.length > 35 ? (task.content.slice(0, 35) + '...'): task.content :

															(
																(Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
																(	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
																	((((task.durationInMinute)/60).toFixed(2))) > 2
																) 
															) ? 
															task.content.length > 55 ? (task.content.slice(0, 55) + '...'): task.content  : 

															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
																( 
																	(Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 3
																) 
															)? 
															task.content.length > 68 ? (task.content.slice(0, 68) + '...'): task.content 

															: task.content.length > 70 ? (task.content.slice(0, 70) + '...') : task.content
														}}
													</span>

													<span v-if="$vuetify.breakpoint.width >= 1800" class="fs-12">
														
														{{	
															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
																(Number(((task.durationInMinute)/60).toFixed(2))) < 2 
															) ? 
															task.content.length > 60 ? (task.content.slice(0, 60) + '...'): task.content :

															(
																(Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
																(	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 2
																) 
															) ? 
															task.content.length > 90 ? (task.content.slice(0, 90) + '...'): task.content  : 

															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
																( 
																	(Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 3
																) 
															)? 
															task.content.length > 100 ? (task.content.slice(0, 100) + '...'): task.content 

															: task.content.length > 115 ? (task.content.slice(0, 115) + '...') : task.content
														}}
													</span>
												</v-col>
											</v-row>
											<v-row v-if="0">
												<v-col cols="12" class="text-start py-0" align-self="end">
													<v-icon 
														size="15" 
														class="me-1" 
														:class="{
															'white--text': task.isDone
														}"
													> 
														mdi-clock-time-four-outline  
													</v-icon>
													<span v-if="task.isDone" class="fs-11 white--text">
														{{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
													</span>
													<span class="fs-11" :class="{'white--text': task.isDone}"> 
														/ {{ task.durationInMinute / 60 }} h
													</span>
													
												</v-col>
											</v-row>
											<!--  -->
											<v-row class="">
												<v-col align-self="end" cols="12" class=" py-1">
													<v-row justify="end">
														<v-col cols="auto" class="text-start" align-self="start">
															<v-icon 
																size="15" 
																class="me-1" 
																:class="{
																	'white--text': task.isDone
																}"
															> 
																mdi-clock-time-four-outline  
															</v-icon>
															<span class="fs-11" :class="{'white--text': task.isDone}"> 
																{{ task.durationInMinute / 60 }} h
															</span>
															<span v-if="task.isDone" class="fs-11 white--text">
																/ {{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
															</span>
														</v-col>
														<v-spacer />
														<v-row 
															cols="auto" 
															align="center" 
															class=" py-0 d-flex"
															:class="{
																'justify-center': $vuetify.breakpoint.lg,
																'justify-end mx-1': $vuetify.breakpoint.mdAndDown
															}"
														>
															<v-btn	
																v-if="
																	(
																		$route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
																	) || 
																	(
																		$route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days'))
																	)
																"
																icon
																@click="rowId = day.id; taskId = task.id; dialog = true"
																:disabled="loading"
																:color="task.isDone ? 'white' :  'gray' "
															>
																<v-icon small> mdi-pencil </v-icon>
															</v-btn>

															<v-btn 
																icon 
																v-else 
																@click="rowId = day.id; taskId = task.id; view = true; dialog = true"
																x-small
															>
																<v-icon :color="task.isDone ? 'white' : 'edit-color'"> mdi-eye </v-icon>
															</v-btn>
														
															<v-btn
																v-if="
																	(
																		$route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
																	) || 
																	(
																		$route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days'))
																	)
																"
																:disabled="loading"
																icon
																@click="taskId = task.id; deleteDialog = true"
																:color="task.isDone ? 'white' :  'gray' "
															>
																<v-icon small> mdi-delete </v-icon>
															</v-btn>
															<v-btn
																:disabled="task.doneLoading"
																icon
																@click="taskId = task.id; status = task.isDone; 
																changeToDone(task)"
																:color="task.isDone ? 'white' : 'green' "
																:loading="Boolean(task.doneLoading)"
															>
																<v-icon v-if="task.isDone">
																	mdi-swap-horizontal 
																</v-icon>
																<v-icon v-if="!task.isDone" small> 
																	mdi-check-circle  
																</v-icon>
															</v-btn>
														</v-row>
													</v-row>
												</v-col>
											</v-row>
										</v-col>
										
									</div>

									<v-btn
										v-if="
										((
											$route.params.id && 
											moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
										) || 
										( 
											$route.params.id && 
											moment().isBefore(moment(startDatePlan).add(2, 'days'))
										)) &&
										day.tasks.map(c => c.durationInMinute).reduce((a, b) => a + b) / 60 <= 10 
										"
										class="align-self-center rounded-lg mx-2"
										width="3px"
										x-small
										height="80px"
										color="success-light white--text"
										@click="resetAll(); rowId = day.id; dialog = true"
										:disabled="loading"
									>
										<v-icon> mdi-plus </v-icon>	
									</v-btn>
								</v-col>
							</v-row>
							<v-divider class="" />
						</v-col>
					</template>
				</v-card-text>
			</v-card>

			<!-- add plan -->
			<v-dialog width="450" v-model="newPlanDialog">
				<v-card class="rounded-lg pa-1">
					<v-card-title class="pb-0 Urbanist-font">
						Add Plan
					</v-card-title>
					<v-form ref="form" @submit.prevent="addPlan">
						<v-card-text class="">
							<v-row class="px-0">
								<v-col cols="12" align-self="start" class="mt-0">
									<v-radio-group v-model="period" row dense hide-details class="mt-0">
										<v-radio
											label="Week"
											:value="1"
										></v-radio>
										<v-radio
											label="Period"
											:value="2"
										></v-radio>
									</v-radio-group>
								</v-col>
								<v-col cols="6" align-self="center" class="pb-0 pt-2 px-1">
									<bee-date-picker
										v-model="planData.startDatePlan"
										input-label="Start date"
										input-format-order="DD-MM-YYYY"
										dense
										class="rounded-lg"
										hide-details="auto"
										menu-picker
										months-over-max="1"
										:rules="period === 1 ? [val => moment(val).format('dddd').slice(0, 3) === 'Sat'] : []"
										:input-props="{
											readonly: true,
											outlined: false,
											filled: false,
											dense: true,
											clearable: true,
											prependIcon: 'mdi-calendar-plus'
										}"
									></bee-date-picker>
								</v-col>

								<v-col align-self="center" cols="6" class="pb-0 pt-2 px-1">
									<bee-date-picker
										v-model="planData.endDatePlan"
										input-label="End date"
										input-format-order="DD-MM-YYYY"
										dense
										class="rounded-lg"
										menu-picker
										months-over-max="1"
										hide-details="auto"
										:input-props="{
											dense: true,
											outlined: false,
											prependIcon: 'mdi-calendar',
											filled: false,
											clearable: true,
										}"
										:rules="period === 1 ? [val => (moment(val).format('dddd').slice(0, 3) === 'Thu')] : []"
									></bee-date-picker>
								</v-col>

								<v-col v-if="0" cols="12" class="py-0 px-1"> 
									<v-checkbox v-model="planData.isActive" hide-details class="mb-0 mt-0" label="Is active" /> 
								</v-col>

								<v-col cols="12" class="pb-0">
									<div class="d-flex">
										<h5 class="me-1"> Plan duration </h5> 
										{{ (planData.endDatePlan && planData.startDatePlan) ? moment(planData.endDatePlan).diff(planData.startDatePlan, 'days') : '-' }}
									</div>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions class="pt-3">
							<v-spacer />
							<v-btn
								type="submit"
								:color="taskId ? 'edit-color' : 'success-light'"
								class="white--text rounded-lg text-none"
								:loading="submitLoading"
							>
								<v-icon small color="white"> 
									mdi-plus
								</v-icon>
								Add
							</v-btn>

							<v-btn
								@click="newPlanDialog = false"
								class="rounded-lg text-none"
								color="alert-color white--text"
								:disabled="submitLoading"
							>
								Cancel 
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</v-dialog>
			<!-- dialog add task in plan -->
			<v-dialog v-model="dialog" width="400" class="rounded-lg">
				<v-card class="rounded-lg pa-1">
					<v-form ref="taskDetails" @submit.prevent="addOrEditItemToRow">
						<v-card-title class="pb-3 Urbanist-font">
							{{ taskId ? 'Edit Task' : 'Add Task'}}
						</v-card-title>
						<v-card-text>
							<v-row class="px-2">
								<v-col cols="12" class="pb-0 pt-2 px-0">
									<bee-date-picker
										v-model="taskDate"
										input-label="Date"
										input-format-order="DD-MM-YYYY"
										dense
										class="rounded-lg"
										hide-details
										:menu-picker="menuPickerEnd"
										:active-picker.sync="activePickerEnd"
										months-over-max="1"
										:input-props="{
											readonly: view,
											outlined: true,
											filled: true,
											dense: true,
											clearable: true,
											prependIcon: 'mdi-calendar-plus'
										}"
										:readonly="view"
									></bee-date-picker>
								</v-col>
								<v-col cols="12" class="pb-0 pt-2 px-0">
									<v-autocomplete
										v-model="project"
										:items="userTypeUser === userType.Developer ? currentUserProjects : projectsBrief"
										item-text="name"
										item-value="id"
										dense
										outlined
										filled
										hide-details
										label="Project Name"
										class="rounded-lg"
										:readonly="view"
										:rules="rules.required"
									/>
								</v-col>

								<v-col cols="12" class="pb-0 pt-2 px-0">
									<v-text-field 
										v-model.number="taskNo"
										label="Task No (on Plan)" 	
										dense
										outlined
										filled
										hide-details 
										class="rounded-lg"
										:rules="rules.requiredAsNumber"
										:readonly="view"
									/>
								</v-col>
							
								<!-- Duration -->
								<v-col cols="12" class="pb-0 pt-2 px-0">
									<v-text-field 
										v-model.number="hours"
										label="Hours" 	
										dense
										outlined
										filled
										class="rounded-lg"
										:rules="rules.requiredAsNumber && [val => val <= 4 ]"
										hide-details="auto"
										:readonly="view"
									/>
								</v-col>

								<v-col cols="12" class="pb-0 pt-2 px-0">
									<v-textarea
										v-model="task"
										:value="task"
										counter
										:rules="rule"
										dense
										filled
										label="Task description"
										dir="auto"
										:readonly="view"
									/>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions class="pt-1">
							<v-spacer />
							<v-btn
								v-if="!view"
								@click="addOrEditItemToRow"
								:color="taskId ? 'edit-color' : 'success-light'"
								class="white--text rounded-lg text-none"
								:loading="submitLoading"
							>
								<v-icon small color="white"> 
									{{ taskId ? 'mdi-pencil' : 'mdi-plus'}} 
								</v-icon>
								{{ taskId ? 'Edit': 'Add' }}
							</v-btn>

							<v-btn
								@click="dialog = false"
								class="rounded-lg text-none"
								color="alert-color white--text"
								:disabled="loading"
							>
								Cancel 
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</v-dialog>

			<!-- delete dialog -->
			<v-dialog v-model="deleteDialog" width="400">
				<v-card>
					<v-card-title>
						Delete Task
					</v-card-title>
					<v-card-text>
						Are you sure you want to delete this task ?
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="alert-color white--text"
							class="rounded-lg text-none"
							:loading="submitLoading"
							@click="deleteTask()"
						>
							Yes
						</v-btn>
						<v-btn
							@click="deleteDialog = false"
							class="rounded-lg text-none"
							:disabled="submitLoading"
						>
							No
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>

		<div v-if="loading" class="d-flex justify-center align-center" style=" height: 100% ">
			<div>
				<div 
					:class="{
						'loader': !$vuetify.theme.dark,
						'loader-dark': $vuetify.theme.dark
					}" 
				></div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
import rules from '@/helper/validation rules.js'
import { mapState } from 'vuex'
import { userType } from '@/helper/enum'
export default {
	watch: {
		dialog (val) {
			if (this.taskId) {
				const task = this.week.find(c => c.id === this.rowId)?.tasks.find(c => c.id === this.taskId)
				this.project = task?.projectId
				this.hours = task.durationInMinute ? Number((task?.durationInMinute / 60).toFixed(2)) : 0
				this.taskNo = task?.taskNo
				this.task = task?.content
				this.taskDate = moment(task?.date).format('YYYY-MM-DD')
			} else {
				this.taskDate = this.week.find(c => c.id === this.rowId)?.date
			}
			if (!val) {
				this.rowId = null
				this.taskId = null
				this.project = null
				this.hours = 0
				this.taskNo = 0
				this.task = null
				this.$refs.taskDetails.resetValidation()
				this.$refs.taskDetails.reset()
				this.view = false
			}
		},

		newPlanDialog (val) {
			if (val === false) {
				this.planData.startDatePlan = null
				this.planData.endDatePlan = null
				this.$refs.form.resetValidation()
			}
		},

		period (val) {
			if (val === 2) {
				this.planData.endDatePlan = null
				this.planData.startDatePlan = null
				this.$refs.form.resetValidation()
			} else {
				this.planData.endDatePlan = moment(this.moment(this.moment().endOf('week')).subtract(2, 'day')).format('YYYY-MM-DD')
				this.planData.startDatePlan = moment(this.moment(this.moment().startOf('week')).subtract(1, 'day')).format('YYYY-MM-DD')
			}
		}
	},

	data () {
		return {
			searchText: null,
			status: null,
			view: false,
			allUserPlan: [],
			previous: false,
			planIsDone: false,
			userType,
			notAllowAddPlan: false,
			currentPlan: [],
			rule: [v => v?.length >= 30 || 'Min 30 characters'],
			submitLoading: false,
			loading: false,
			startDatePlan: null,
			endDatePlan: null,
			planData: {
				startDatePlan: moment(this.moment(this.moment().startOf('week')).subtract(1, 'day')).format('YYYY-MM-DD'),
				endDatePlan: moment(this.moment(this.moment().endOf('week')).subtract(2, 'day')).format('YYYY-MM-DD'),
				isActive: false
			},
			date: null,
			menuPicker: true,
			activePicker: null,

			menuPickerEnd: true,
			activePickerEnd: null,

			newPlanDialog: false,
			deleteDialog: false,
			rules,
			rowId: null,
			dialog: false,
			project: null,
			
			hours: 0,
			taskNo: 0,
			taskId: null,
			myDate: moment().subtract(1, 'days'),
			task: null,
			userIdUser: null,
			planByEmployee: [],
			noPlan: false,
			taskDate: null,

			// table in md and sm size
			headers: [
				{
					text: 'Day',
					value: 'name'
				},
				{
					text: 'Project',
					value: 'tasks'
				},
				{
					text: 'Details',
					value: 'details'
				},
				{
					text: 'time',
					value: 'time'
				},
				{
					text: 'actions',
					value: 'actions'
				}
			],
			period: 1,
			items: [
				{
					id: '053b94c5-cc52-44a8-30e2-08dce5323ba7o',
					createdAt: '2024-10-05T11:38:29.1690774',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: 'e8dd2ee0-dcbd-4bc8-6527-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'push rowad al mustakbal dist to server',
					durationInMinute: 30,
					taskNo: 14183,
					isDone: true,
					actualDuration: 0
				},
				{
					id: '8aadf381-0aed-4171-30e3-08dce5323ba7g',
					createdAt: '2024-10-05T11:49:41.8801153',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '0ee2423e-cbc0-4db1-64da-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'planning to set plan to projects',
					durationInMinute: 60,
					taskNo: 0,
					isDone: true,
					actualDuration: 35
				},
				{
					id: '72ff174d-5d9a-4d57-30e4-08dce5323ba70',
					createdAt: '2024-10-05T11:50:42.0941249',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: 'f0f9870c-c135-44e3-657c-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'meeting with qamar to discuss new edits to ugarit after 1.5.5 communication',
					durationInMinute: 60,
					taskNo: 14279,
					isDone: true,
					actualDuration: 78
				},
				{
					id: '9ddd7f51-9735-402d-30e5-08dce5323ba71',
					createdAt: '2024-10-05T11:51:58.2673136',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: 'e8dd2ee0-dcbd-4bc8-6527-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: '(optional) push schools - meeting to fix core problem ',
					durationInMinute: 60,
					taskNo: 14275,
					isDone: true,
					actualDuration: 0
				},
				{
					id: 'da3998c9-2e5e-404b-30e6-08dce5323ba72',
					createdAt: '2024-10-05T11:52:51.2037623',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'planning to set al radwan edits and set task to the team',
					durationInMinute: 30,
					taskNo: 14274,
					isDone: true,
					actualDuration: 0
				},
				{
					id: 'e8cbd481-72d4-4c87-30e7-08dce5323ba74',
					createdAt: '2024-10-05T11:53:33.158368',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'al radwan new edits after training session',
					durationInMinute: 180,
					taskNo: 14269,
					isDone: false,
					actualDuration: 42
				},
				{
					id: '8aadf381-0aed-4171-30e3-08dce5323ba79',
					createdAt: '2024-10-05T11:49:41.8801153',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '0ee2423e-cbc0-4db1-64da-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'planning to set plan to projects',
					durationInMinute: 60,
					taskNo: 0,
					isDone: true,
					actualDuration: 35
				},
				{
					id: '72ff174d-5d9a-4d57-30e4-08dce5323ba71',
					createdAt: '2024-10-05T11:50:42.0941249',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: 'f0f9870c-c135-44e3-657c-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'meeting with qamar to discuss new edits to ugarit after 1.5.5 communication',
					durationInMinute: 60,
					taskNo: 14279,
					isDone: true,
					actualDuration: 78
				},
				{
					id: '9ddd7f51-9735-402d-30e5-08dce5323ba78',
					createdAt: '2024-10-05T11:51:58.2673136',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: 'e8dd2ee0-dcbd-4bc8-6527-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: '(optional) push schools - meeting to fix core problem ',
					durationInMinute: 60,
					taskNo: 14275,
					isDone: true,
					actualDuration: 0
				},
				{
					id: 'da3998c9-2e5e-404b-30e6-08dce5323ba71',
					createdAt: '2024-10-05T11:52:51.2037623',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'planning to set al radwan edits and set task to the team',
					durationInMinute: 30,
					taskNo: 14274,
					isDone: true,
					actualDuration: 0
				},
				{
					id: 'e8cbd481-72d4-4c87-30e7-08dce5323ba72',
					createdAt: '2024-10-05T11:53:33.158368',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'al radwan new edits after training session',
					durationInMinute: 180,
					taskNo: 14269,
					isDone: false,
					actualDuration: 42
				}
			],
			oldIndex: null,
			newIndex: null,
			showDraft: false,
			taskDraftId: null,
			dateDate: null
		}
	},

	computed: {
		...mapState({
			userId: state => state.auth.self.id,
			self: state => state.auth.self,
			currentUserProjects: state => state.projects.currentUserProjects,
			plan: state => state.plan.plan,
			userTypeUser: state => state.auth.self.userType,
			usersWithoutPag: state => state.users.usersWithoutPag,
			projectsBrief: state => state.projects.projectsBrief
		}),
		// noPlan() {
		// 	currentPlan.length === 0
		// },
		// isDone() {
		// 	if(this)
		// }, 

		week () {
			return [
				{
					name: 'Sat',
					id: 1,
					tasks: [],
					date: moment(this.startDatePlan).format('YYYY-MM-DD')
				},
				{
					name: 'Sun',
					id: 2,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(1, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Mon',
					id: 3,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(2, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Tue',
					id: 4,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(3, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Wen',
					id: 5,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(4, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Th',
					id: 6,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(5, 'days')).format('YYYY-MM-DD')
				}
				// {
				// 	name: 'Undefined',
				// 	id: 7,
				// 	tasks: [],
				// 	date: null
				// }
			]
		},
		myDraft () {
			let items = []
			if (this.searchText === null) {
				items = this.items
			}
			return items
		}
	},

	methods: {
		moment,
		pushDataInTheWeek (data) {
			const tasks = data
			this.week.map(c => (c.tasks = []))
			for (let i = 0; i < tasks?.length; i++) {
				if (this.week.find(c => moment(moment(c.date).format('YYYY-MM-DD')).isSame(moment(tasks[i].date).format('YYYY-MM-DD'), 'day'))) {
					this.week.find(c => moment(c.date).isSame(tasks[i].date, 'day'))?.tasks.push({
						...tasks[i],
						doneLoading: false
					})
				}
			}
			return this.week
		},

		getTasksByPlanId () {
			return this.$store.dispatch('plan/fetchPlannedTask', { planId: this.$route.params.id }).then((data) => {
				this.pushDataInTheWeek(data)
			})
		},

		next () {
			this.startDatePlan = moment(this.endDatePlan).add(2, 'day').format('YYYY-MM-DD')
			this.endDatePlan = moment(this.startDatePlan).add(5, 'day').format('YYYY-MM-DD');
			return this.startDatePlan
		},

		// previous () {
		// 	this.startDatePlan = moment(this.startDatePlan).subtract(7, 'day').format('YYYY-MM-DD')
		// 	this.endDatePlan = moment(this.startDatePlan).add(5, 'day').format('YYYY-MM-DD')
		// 	return this.startDatePlan	
		// },

		addOrEditItemToRow () {
			if (this.$refs.taskDetails.validate()) {
				this.submitLoading = true
				// this.loading = true
				const actionName = this.taskId ? 'updateTask' : 'createTask'
				this.$store.dispatch(`plan/${actionName}`, {
					id: this.taskId,
					planId: this.$route.params.id,
					project: null,
					projectId: this.project,
					content: this.task,
					durationInMinute: (this.hours * 60),
					taskNo: this.taskNo,
					// isDone:
					date: this.taskDate
				}).then(() => {
					this.getById(this.$route.params.id).finally(() => {
						this.loading = false
						this.dialog = false
					})
				}).finally(() => {
					this.submitLoading = false
				})
			}
		},

		deleteItem () {
			this.submitLoading = true
			this.$store.dispatch('plan/deletePlannedTask', { id: this.taskId }).then(() => {
				this.submitLoading = false
			})
		},

		resetAll () {
			this.rowId = null
			this.taskId = null
			this.project = null
			this.hours = 0
			this.taskNo = 0
			this.task = null
		},

		addPlan () {
			if (this.$refs.form.validate()) {
				this.submitLoading = true
				this.$store.dispatch('plan/create', {
					startDate: this.moment(this.planData.startDatePlan).format('YYYY-MM-DD') + 'T' + '23:59:59', 
					endDate: this.planData.endDatePlan, 
					isActive: true, 
					userId: this.userIdUser ? this.userIdUser : this.userId
					// this.planData.isActive,
				}).then((data) => {
					this.getById(data)
					this.planIsDone = false
					this.$router.push({
						name: 'weekly-plan',
						params: { id: data }
					})
				}).finally(() => {
					this.submitLoading = false
					this.newPlanDialog = false
				})
			}
		},

		getById (id) {
			return this.$store.dispatch('plan/fetchById', { id: id }).then((data) => {
				if (!this.$route.params.id) {
					this.$router.push({
						params: {
							id: id
						}
					})
				}
				this.currentPlan = data
				this.startDatePlan = data.startDate
				this.endDatePlan = data.endDate

				this.pushDataInTheWeek(data.plannedTasks)
			})
		},

		getPlanBetweenTwoDate () {
			// this.week.map(c => (c.tasks = []))
			// this.$store.dispatch('plan/fetchPlanBetweenTwoDate', { 
			// 	from: this.moment(this.startDatePlan).format('MM-DD-YYYY'), 
			// 	to: this.moment(moment(this.startDatePlan).add(7, 'days')).format('MM-DD-YYYY')
			// }).then((data) => {
			// 	if (data?.length !== 0) {
			// 		if (this.$route.params.id !== data[0]?.id) {
			// 			this.$router.push({
			// 				name: 'weekly-plan',
			// 				params: { id: data[0].id }
			// 			})
			// 		}
			
			// 		this.startDatePlan = data[0].startDate
			// 		this.endDatePlan = data[0].endDate

			// 		this.pushDataInTheWeek(data[0]?.plannedTasks)
			// 	} else {
			// 		if (this.$route.params.id) {
			// 			this.$router.push({
			// 				name: 'weekly-plan'
			// 			})	
			// 		}
			// 	}
			// })
			if (this.allUserPlan.length !== 0 || this.planByEmployee.length !== 0) {
				const plan = this.userTypeUser === this.userType.Developer ? this.allUserPlan : this.planByEmployee
				let index = plan.indexOf(plan.find(c => c.id === this.$route.params.id))
				console.log(index)
				if (this.previous === true) {
					index = index + 1	
					if (this.userTypeUser === userType.Developer) {
						var data = this.allUserPlan[index]
					} else {
						data = this.planByEmployee[index]
					}
					this.startDatePlan = data.startDate
					this.endDatePlan = data.endDate
					this.pushDataInTheWeek(data.plannedTasks)
					
					this.$router.push({
						name: 'weekly-plan',
						params: { id: data.id }
					})

					console.log(data)
				} else {
					index = index - 1 
					if (this.userTypeUser === userType.Developer) {
						data = this.allUserPlan[index]
					} else {
						data = this.planByEmployee[index]
					}
					this.startDatePlan = data.startDate
					this.endDatePlan = data.endDate
					this.pushDataInTheWeek(data.plannedTasks)
					this.$router.push({
						name: 'weekly-plan',
						params: { id: data.id }
					})
					// }
				}
			}
		},

		deleteTask () {
			this.loading = true
			this.submitLoading = true
			this.$store.dispatch('plan/deletePlannedTask', { id: this.taskId }).then(() => {
				this.submitLoading = false
				this.deleteDialog = false
				this.getTasksByPlanId().finally(() => {
					this.loading = false
				})
			})
		},

		getActivePlanForUser () {
			this.onPlan = false
			this.loading = true
			this.$store.dispatch('plan/fetchPlanByUser', { userId: this.userIdUser }).then((data) => {
				if (data?.length !== 0) {
					this.planByEmployee = data
					if (!this.$route.params.id) {
						this.$router.push({
							name: 'weekly-plan',
							params: { id: data[0].id }
						})
					}
			
					this.startDatePlan = data[0].startDate
					this.endDatePlan = data[0].endDate
					this.pushDataInTheWeek(data[0]?.plannedTasks)
				} else {
					this.pushDataInTheWeek([])
					this.noPlan = true
				}
			}).finally(() => {
				this.loading = false	
			})
		},

		changeToDone (task) {
			task.doneLoading = true
			this.$store.dispatch('plan/changeStatusPlannedTask', { id: this.taskId, isDone: !(this.status) }).then(() => {
				this.getById(this.$route.params.id)
			}).finally(() => {
				task.doneLoading = false
			})
		},

		updatePlanToDone () {
			// this.$store.dispatch()	
			this.loading = true
			this.$store.dispatch('plan/update', {
				id: this.$route.params.id, 
				startDate: this.startDatePlan,
				endDate: this.endDatePlan,
				isActive: false, 
				userId: this.userTypeUser === userType.Developer ? this.userId : this.userIdUser
			}).then(() => {
				this.notAllowAddPlan = false
				this.planIsDone = true
			}).finally(() => {
				this.loading = false
			})
		},

		dragStart: function (event) {
			event.dataTransfer.setData('Text', event.target.id);
			// console.log(event.target.id)
			const array = []
			this.taskDraftId = event.target.id
			array.push(this.taskDraftId)
			console.log(array)
		},
		dragging: function (event) {
			// document.getElementById('demo').innerHTML = 'The p element is being dragged';
			// document.getElementById('card').classList.remove('w-100')
			// document.getElementById('card').classList.add('w-100')
			// document.getElementById('card').classList.add('width-1')
			// document.getElementById('card').classList.remove('w-100')
		},
		allowDrop: function (event) {
			event.preventDefault();
		},
		drop: function (event) {
			// console.log(event)
			event.preventDefault();
			var data = event.dataTransfer.getData('Text');
			event.target.appendChild(document.getElementById(data))	

			const dataTask = this.items.find(c => c.id === this.taskDraftId)
			this.$store.dispatch('plan/createTask', {
				id: dataTask.id,
				planId: this.$route.params.id,
				project: dataTask.projectId,
				// projectId: this.project,
				content: dataTask.content,
				durationInMinute: dataTask.durationInMinute,
				taskNo: dataTask.taskNo,
				// isDone:
				date: this.dateDate
			}).then(() => {
				this.getById(this.$route.params.id).finally(() => {
					this.loading = false
					this.dialog = false
				})
			}).finally(() => {
				this.submitLoading = false
			})
			// get new draft
			// $store.dispatch()
		}
	},

	created () {
		if (this.userTypeUser === userType.Admin || this.userTypeUser === userType.Administrative) {
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true })
			this.$store.dispatch('projects/fetchProjectBrief')
		} else {
			this.$store.dispatch('projects/fetchCurrentUserProjects')
		}
		
		this.$store.dispatch('plan/fetchAll')
		this.$store.dispatch('plan/fetchActivePlanForUser', { userId: this.userId }).then((data) => {
			this.allUserPlan = data
			if (data?.length !== 0) {
				// Assuming there is always one active plan
				if ((!this.$route.params.id && data.length) || (this.$route.params.id !== data[0].id && data.length)) {
					this.$router.push({
						name: 'weekly-plan',
						params: { id: data[0].id }
					})
				}

				this.currentPlan = data
				this.startDatePlan = data[0].startDate
				this.endDatePlan = data[0].endDate

				if (data[0]?.plannedTasks.length) {
					this.pushDataInTheWeek(data[0]?.plannedTasks)
				}
				if (this.week.map(c => c.date).includes(this.moment().format('YYYY-MM-DD'))) {
					this.notAllowAddPlan = true
				} else {
					// this.loading = true
					// this.$store.dispatch('plan/update', {
					// 	id: this.$route.params.id, 
					// 	startDate: data[0]?.startDate,
					// 	endDate: data[0]?.endDate,
					// 	isActive: false, 
					// 	userId: this.userId
					// }).then(() => {
					// 	this.notAllowAddPlan = false
					// }).finally(() => {
					// 	this.loading = false
					// })
				}
				return this.week
			} else {
				this.planIsDone = true
			}
		})
	}
}
</script>

<style scoped lang="scss">
/* HTML: <div class="loader"></div> */

/* HTML: <div class="loader"></div> */
fieldset {
	color: rgba(216, 216, 216, 0.507) !important
}

// width for hours
.width-1 {
	width: 19%;
}
.width-2 {
	width: 20%;
}
.width-3 {
	width: 23%
}
.width-4 {
	width: 25%
}
.w-100 {
	width: 100%
}
.hover:hover {
	border-radius: 30px;
}

// style
.week-card {
	height: 850
}
.h-one-row {
	height: 150px
}
.task-card {
	height: 90px; 
	// background-color: #
}
.h-auto {
	height: auto;
}
.task-card-done {
	height: 90px;
	background-color: #2E9859;
}
.no-task-style {
	align-content: center; 
	color: #0B759D; 
}
.no-task-style-green {	
	align-content: center; 
	color: white; 
}
.bg-light-green {
	background-color: #8cc3a2; 
}
.bg-light-blue {
	background-color: #E8F4F8; 
}
.bg-light-grey {
	background-color: #878787;
}
.fs-11 {
	font-size: 11px
}
.padding-color-small {
	width: 10px; 
	height: 65px; 
	background-color: rgb(21, 92, 185)
}
.style-small-draft-card {
	width: 100%; 
	height: 65px; 
	border: 3px solid #f6f6f6  
}
.droptarget {
	float: left; 
	width: 100%; 
	height: 100px;
	margin: 15px;
	padding: 10px;
	// border: 1px solid #aaaaaa
}

.scroll-style {
    float:left;
    width: 100%;
    overflow-y: auto;
    height: auto;
}
</style>
